module.exports = __webpack_public_path__ + "static/media/ic-plus.153d6826.svg";